export type DeviceClass = 'phone' | 'desktop' | 'other';

const TV_RE = /TV|AFT|BRAVIA|Tizen|Web0S|WebOS|GoogleTV|CrKey|HbbTV|NetCast|SMART-?TV|DTV/i;
const DESKTOP_OS_RE = /Windows NT|Macintosh|X11|Linux x86|Linux i686|CrOS/;

/**
 * Классификация устройства для маршрутизации входа.
 * Порядок важен: сперва ТВ-исключения, затем телефон (Mobile), затем десктоп.
 * @param ua navigator.userAgent
 * @param hasFinePointer matchMedia('(pointer:fine)').matches — есть мышь
 */
export function deviceClass(ua: string, hasFinePointer: boolean): DeviceClass {
  if (TV_RE.test(ua)) return 'other';
  if (/Mobile/.test(ua)) return 'phone';        // Android-телефоны и iPhone содержат "Mobile"
  if (!/Android/.test(ua) && DESKTOP_OS_RE.test(ua) && hasFinePointer) return 'desktop';
  return 'other';                                // Android TV без Mobile, приставки, неизвестное
}

/** Телефон или десктоп → показываем логин сразу; иначе → страница скачивания. */
export function isLoginFirst(ua: string, hasFinePointer: boolean): boolean {
  const c = deviceClass(ua, hasFinePointer);
  return c === 'phone' || c === 'desktop';
}
